import React from 'react';
import { cn } from '../../lib/utils';

const InputGroup = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded-md border border-input bg-background text-sm ring-offset-background focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 has-[input:disabled]:cursor-not-allowed has-[input:disabled]:opacity-50",
        className
      )}
      {...props}
    />
  );
});

const InputGroupInput = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      className={cn(
        "flex h-full w-full border-0 bg-transparent px-3 py-2 text-sm placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  );
});

const InputGroupAddon = React.forwardRef(({ className, align = "inline-start", ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "flex shrink-0 items-center text-muted-foreground",
        align === "inline-start" && "pl-3",
        align === "inline-end" && "pr-3",
        className
      )}
      {...props}
    />
  );
});

InputGroup.displayName = "InputGroup";
InputGroupInput.displayName = "InputGroupInput";
InputGroupAddon.displayName = "InputGroupAddon";

export { InputGroup, InputGroupInput, InputGroupAddon };